import {
  IModelMapper,
  ISimpleCRUDServiceFactory
} from "../../../service/SimpleCRUDServiceFactory";

export default class CreateFileResourceInteractor<T> {
  private serviceFactory: ISimpleCRUDServiceFactory<T>;

  constructor({ simpleCRUDServiceFactory }: any) {
    this.serviceFactory = simpleCRUDServiceFactory;
  }

  async execute(
    basePath: string,
    ModelMapper: IModelMapper<T>,
    file: any,
    data: FormData
  ) {
    const result = await this.serviceFactory
      .create({
        basePath,
        ModelMapper
      })
      .createFileResource(file, data);
    return result;
  }
}
